import React, { Component, Fragment, useEffect, useLayoutEffect } from "react";
import { withRouter, useHistory, useLocation } from "react-router-dom";

import MetisMenu from "react-metismenu";

// import {
//   MainNav,
//   ComponentsNav,
//   FormsNav,
//   WidgetsNav,
//   ChartsNav,
// } from "./NavItems";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Roles } from "../../utils/Roles";
import axios from "axios";
import cookie from "react-cookies";
import { resetStateAction } from "../../reducers/ResetReducer";
import Storage from "../../services/Storage";
import { icon } from "@fortawesome/fontawesome-svg-core";

const API_URL = process.env.REACT_APP_API_URL;

// class Nav extends Component {
//   state = {};
// }

// Functional Nav component
const Nav = () => {
  let userData = useSelector((state) => state.UserReducer.userObj);
  const lang = useSelector((state) => state.LanguageReducer.current) || 'en';
  const impersonation = useSelector((state) => state.ImpersonationReducer);
  const [selected, setSelected] = useState("");
  const [selectedHref, setSelectedHref] = useState('#' + (useLocation().pathname || ''));
  let history = useHistory();
  let location = useLocation();

  // Restore missing menu selection handler to prevent onMenuSelected undefined error
  const onMenuSelected = (e) => {
    // MetisMenu passes event-like object; attempt to derive label/name
    try {
      const target = e?.currentTarget || e?.target;
      const name = target?.getAttribute?.("name") || target?.textContent?.trim();
      // Prefer stable href over label for selection persistence
      const anchor = target?.closest?.('a') || target;
      const href = anchor?.getAttribute?.('href');
      if (href) {
        setSelectedHref(href);
        sessionStorage.setItem('selectedMenuHref', href);
      } else if (name) {
        // Fallback: keep label for legacy behavior
        setSelected(name);
      }
    } catch (_) {
      // Fail silently; selection state is non-critical
    }
  };

  // Restore selected menu item on language change
  useEffect(() => {
    const savedHref = sessionStorage.getItem('selectedMenuHref');
    if (savedHref) {
      setSelectedHref(savedHref);
    } else {
      // Default to current route
      setSelectedHref('#' + location.pathname);
    }
  }, [lang]);

  // Keep selection in sync with route changes
  useEffect(() => {
    setSelectedHref('#' + location.pathname);
  }, [location.pathname]);

  const handleLogout = () => {
    //const { userData } = this.props;
    let sessionid = userData && userData?.sessionid;
    let obj = {
      sessionid,
    };
    axios
      .post(`${API_URL}/api/ua/logout/`, obj)
      .then((res) => {
        if (res.status === 200) {
          cookie.remove("user", { path: "/", domain: "siembramobile.com" });
          cookie.remove("sessionid", {
            path: "/",
            domain: "siembramobile.com",
          });
          cookie.remove("role", { path: "/", domain: "siembramobile.com" });
          Storage.removeTokenCookie();
          Storage.removeSessionId();
          Storage.clearLocalStorage();
          Storage.clearSessionStorage();
          // Clear menu selection on logout
          sessionStorage.removeItem('selectedMenuItem');
          history.push("/login");
        }
      })
      .catch((err) => {
        console.log("err: ", err.response);
      });
  };

  // Simple EN/ES labels for Student & Parent menus
  const labels = {
    en: {
      goals: 'Goals',
      myReflections: 'My Reflections',
      myCurriculum: 'My Curriculum',
      myBragBook: 'My Brag Book',
      myMessages: 'My Messages',
      myCalendar: 'My Calendar',
      myColleges: 'My Colleges',
      collegeChecklist: 'College Checklist',
      personalNotes: 'Personal Notes',
      studentGuide: 'Student Guide',
      parentGuide: 'Parent Guide',
      registerYourChild: 'Register Your Child',
      signOut: 'Sign Out'
    },
    es: {
      goals: 'Metas',
      myReflections: 'Mis Reflexiones',
      myCurriculum: 'Mi Plan de Estudios',
      myBragBook: 'Mi Libro de Logros',
      myMessages: 'Mis Mensajes',
      myCalendar: 'Mi Calendario',
      myColleges: 'Mis Universidades',
      collegeChecklist: 'Checklist Universitaria',
      personalNotes: 'Notas Personales',
      studentGuide: 'Guía del Estudiante',
      parentGuide: 'Guía para Padres',
      registerYourChild: 'Registrar a su hijo',
      signOut: 'Cerrar sesión'
    }
  };
  const t = (key) => (labels[lang] || labels.en)[key];

  const studentMenu = [
    // 1) Goals (route varies by verification/status)
    userData?.is_sch_email_verified === true &&
    userData?.student_status === "regular"
      ? {
          icon: "customIcon goalIcon",
          label: t('goals'),
          to: "#/student/goal/cc-requirement",
        }
      : userData?.is_sch_email_verified === false &&
        userData?.student_status === "regular"
      ? {
          icon: "customIcon goalIcon",
          label: t('goals'),
          to: "#/student/dashboard",
        }
      : userData?.is_sch_email_verified === true &&
        userData?.student_status === "brown"
      ? {
          icon: "customIcon goalIcon",
          label: t('goals'),
          to: "#/student/brown-dashboard",
        }
      : null,

    // 2) My Reflections (if required)
    ...(userData?.is_sch_email_verified === true && userData?.need_reflections === true
      ? [
          {
            icon: "customIcon myReflectionListIcon",
            label: t('myReflections'),
            to: "#/student/reflections",
          },
        ]
      : []),

      //3) My Curriculum (if unverified)

      userData?.is_sch_email_verified === false
      ? {
        icon: "customIcon myCurriculumIcon",
        label: t('myCurriculum'),
        to: "#/student/curriculum",      
      }
      : null,

    // 4) My Brag Book
    userData?.is_sch_email_verified === true
      ? {
          icon: "customIcon bragBookIcon",
          label: t('myBragBook'),
          to: "#/student/portfolio/my-passion",
        }
      : {
          icon: "customIcon bragBookIcon",
          label: "My Brag Book",
          to: "#/student/portfolio/my-passion",
        },

    // 5) My Messages
    { icon: "customIcon messageIcon", label: t('myMessages'), to: "#/student/message" },

    // 6) My Calendar
    { icon: "customIcon myCalendarIcon", label: t('myCalendar'), to: "#/student/calendar" },

    // 7) My Colleges
    { icon: "customIcon myCollegeIcon", label: t('myColleges'), to: "#/student/my-colleges" },

    // 8) College Checklist
    { icon: "customIcon collegeCheckListIcon", label: t('collegeChecklist'), to: "#/student/ladder" },

    // 9) Personal Notes
    { icon: "customIcon myNotesIcon", label: t('personalNotes'), to: "#/student/personal-notes" },

    // 10) Student Guide
    {
      icon: "customIcon userBookIcon",
      label: t('studentGuide'),
      externalLink: true,
      to: "https://frontend.siembramobile.com/WebUserguide/Student270124/index.html",
    },

    // 11) Sign Out
    {
      icon: "customIcon signOutIcon",
      label: (
        <span onClick={handleLogout} className="sign-out">{t('signOut')}</span>
      ),
    },
  ];

  const parentMenu = [
    // 1) Goals
    { icon: "customIcon goalIcon", label: t('goals'), to: "#/parent/goal/cc-requirement" },

    // 2) My Reflections (for parent role)
    ...(userData?.role === Roles.PARENT_NAME
      ? [{ icon: "customIcon myReflectionListIcon", label: t('myReflections'), to: "#/parent/reflections" }]
      : []),

    // 3) My Brag Book
    {
      icon: "customIcon bragBookIcon",
      label: t('myBragBook'),
      to: "#/parent/portfolio/my-passion",
    },

    // 4) My Messages
    { icon: "customIcon messageIcon", label: t('myMessages'), to: "#/parent/message" },

    // 5) My Colleges
    { icon: "customIcon myCollegeIcon", label: t('myColleges'), to: "#/parent/my-colleges" },

    // 6) College Checklist
    { icon: "customIcon collegeCheckListIcon", label: t('collegeChecklist'), to: "#/parent/ladder" },

    // 7) Register Your Child
    { icon: "customIcon userBookIcon", label: t('registerYourChild'), to: "#/parent/child-registration" },

    // 8) Parent Guide
    {
      icon: "customIcon userBookIcon",
      label: t('parentGuide'),
      externalLink: true,
      to: "https://frontend.siembramobile.com/WebUserguide/Parent194890/index.html",
    },

    // 9) Sign Out
    {
      icon: "customIcon signOutIcon",
      label: (<span onClick={handleLogout} className="sign-out">{t('signOut')}</span>),
    },
  ];

  const counselorMenu = [
    // Goal Progress
    {
      icon: "customIcon counselorCollegeConnectIcon",
      label: "Goal Progress",
      to: "#/counselor/all-students",
      // content: [
      //   { label: "All Students", to: "#/counselor/all-students" },
      //   { label: "On Track Students", to: "#/counselor/on-track-student" },
      //   { label: "At Risk Students", to: "#/counselor/at-risk-student" },
      //   { label: "Off Track Students", to: "#/counselor/off-track-student" },
      //   { label: "At Brown Students", to: "#/counselor/at-brown-student" },
      //   { label: "Watchlist", to: "#/counselor/watchlist" },
      // ],
    },
    // My Student List
    {
      icon: "customIcon counselorStudentListIcon",
      label: "My Student List",
      to: "#/counselor/current-student",
      // content: [
      //   { label: "Current Student", to: "#/counselor/current-student" },
      //   // { label: "Invite Students", to: "#/counselor/invite-student" },
      //   // { label: "Add Existing Students", to: "#/counselor/add-existing-student" },
      //   { label: "Export File", to: "#/counselor/export-file" },
      // ],
    },
    // Messages
    {
      icon: "customIcon counselorMsgIcon",
      label: "Messages",
      to: "#/counselor/message/student-message",
      // content: [
      //   // { label: "CREATE A NEW MESSAGE" },
      //   // { label: "ALL MESSAGES", to: "#/counselor/message/all-message" },
      //   { label: "Student Messages", to: "#/counselor/message/student-message" },
      //   { label: "Recruiter Messages", to: "#/counselor/message/recruiter-message" },
      //   { label: "Group Messages", to: "#/counselor/message/group-message" },
      //   { label: "Deleted Messages", to: "#/counselor/message/deleted-message" },
      //   // { label: "MESSAGE TEMPLATES" },
      // ],
    },
    // Calendar
    {
      icon: "customIcon counselorCalendarIcon",
      label: "Calendar",
      to: "#/counselor/calendar",
    },
    // Counselor Guide
    {
      icon: "customIcon counselorGuideIcon",
      label: "Counselor Guide",
      externalLink: true,
      to: "https://frontend.siembramobile.com/WebUserguide/Counselor239856/index.html",
    },
    // Account Settings
    {
      icon: "customIcon counselorSettingsIcon",
      label: "Account Settings",
      to: userData?.is_super_counselor === true ? "#/super_admin/profile" : "#/counselor/profile",
    },
    // Sign Out
    {
      icon: "customIcon counselorSignOutIcon",
      label: (<span onClick={handleLogout} className="sign-out">Sign Out</span>),
    },
  ];

  const superCounselorMenu = [
    // Goal Progress
    {
      icon: "customIcon counselorCollegeConnectIcon",
      label: "Goal Progress",
      to: "#/super_admin/all-students",
      // content: [
      //   { label: "All Students", to: "#/super_admin/all-students" },
      //   { label: "On Track Students", to: "#/super_admin/on-track-student" },
      //   { label: "At Risk Students", to: "#/super_admin/at-risk-student" },
      //   { label: "Off Track Students", to: "#/super_admin/off-track-student" },
      //   { label: "At Brown Students", to: "#/super_admin/at-brown-student" },
      // ],
    },
    // My Student List
    {
      icon: "customIcon counselorStudentListIcon",
      label: "My Student List",
      to: "#/super_admin/current-student",
      // content: [
      //   { label: "Current Student", to: "#/super_admin/current-student" },
        // { label: "Invite Students", to: "#/super_admin/invite-student" },
        // { label: "Add Existing Students", to: "#/super_admin/add-existing-student" },
        // { label: "Export File", to: "#/super_admin/export-file" },
      // ],
    },
    // Student Statistics
    {
      icon: "customIcon counselorStudentStatisticsIcon",
      label: "Student Statistics",
      to: "#/super_admin/student_statistics",
      // content: [
      //   { label: "Download Summary", to: "#/super_admin/student_statistics" },
      // ],
    },
    // Messages
    {
      icon: "customIcon counselorMsgIcon",
      label: "Messages",
      to: "#/super_admin/message/student-message",
      // content: [
      //   // { label: "CREATE A NEW MESSAGE" },
      //   // { label: "ALL MESSAGES", to: "#/super_admin/message/all-message" },
      //   { label: "Student Messages", to: "#/super_admin/message/student-message" },
      //   { label: "Recruiter Messages", to: "#/super_admin/message/recruiter-message" },
      //   { label: "Group Messages", to: "#/super_admin/message/group-message" },
      //   { label: "Deleted Messages", to: "#/super_admin/message/deleted-message" },
      // ],
    },
    {
      icon: "customIcon recruiterTemplateIcon",
      label: "Message Templates",
      to: "#/super_admin/message/message-template",
    },
    // Calendar
    {
      icon: "customIcon counselorCalendarIcon",
      label: "Calendar",
      to: "#/super_admin/calendar",
    },
    // Guide
    {
      icon: "customIcon counselorGuideIcon",
      label: "Super Admin Guide",
      externalLink: true,
      to: "https://frontend.siembramobile.com/WebUserguide/SuperAdmin096534/index.html",
    },
    // Account Settings
    {
      icon: "customIcon counselorSettingsIcon",
      label: "Account Settings",
      to: userData?.is_super_counselor === true ? "#/super_admin/profile" : "#/counselor/profile",
    },
    // Sign Out
    {
      icon: "customIcon counselorSignOutIcon",
      label: (<span onClick={handleLogout} className="sign-out">Sign Out</span>),
      // to:"#/login"
    },
  ];

  const recruiterMenu = [
    {
  icon: "customIcon recruiterQueryIcon",
      label: "Student Query",
      to: "#/recruiter/search-query",
      // content: [
      //   {
      //     label: "H/S STUDENT QUERY",
      //     to: "#/recruiter/search-query",
      //   },
      //   {
      //     label: "SAVED QUERIES",
      //     to: "#/recruiter/school-query",
      //   },
      //   {
      //     label: "C/C STUDENT QUERY",
      //     to: "#/recruiter/college-query",
      //   },
      // ],
    },
    {
  icon: "customIcon recruiterMsgIcon",
      label: "Messages",
      to: "#/recruiter/students",
      // content: [
      //   // {
      //   //   label: "CREATE A NEW MESSAGE",
      //   //   // to: "",
      //   // },
      //   // {
      //   //   label: "ALL MESSAGES",
      //   //   // to: "",
      //   // },
      //   {
      //     label: "STUDENTS",
      //     to: "#/recruiter/students",
      //   },
      //   {
      //     label: "INTERNATIONAL STUDENTS",
      //     to: "#/recruiter/international-students",
      //   },
      //   {
      //     label: "COUNSELORS",
      //     to: "#/recruiter/counselors",
      //   },
      // ],
    },
    {
  icon: "customIcon recruiterTemplateIcon",
      label: "Message Templates",
      to: "#/recruiter/canned",
    },
    // Calendar (reuse Counselor Calendar component)
    {
      icon: "customIcon counselorCalendarIcon",
      label: "Calendar",
      to: "#/recruiter/calendar",
    },
    // {
    //   label: "MY STUDENT LIST",
    //   // to: "#",
    // },
    {
  icon: "customIcon recruiterPremiumIcon",
      label: "Premium Services",
      to: "#/recruiter/campaign",
    },
    {
      icon: "customIcon recruiterIcon",
      label: "Recruiter Guide",
      externalLink: true,
      to:
        "https://frontend.siembramobile.com/WebUserguide/Recruiter950378/index.html",
    },
    {
  icon: "customIcon recruiterSignOutIcon",
      label: (
        <span onClick={handleLogout} className="sign-out">
          Sign Out
        </span>
      ),
    },
  ];

  let schoolItMenu = [
    // {
    //         label: "School Setup",
    //         to: "#/school_it/school_setup",
    // },
    {
      label: "Student Statistics",
      to: "#/school_it/student_statistics",
    },
    {
      label: "Message Center",
      to: "#/school_it/message_center",
    },
    {
      label: "Student Messages",
      to: "#/school_it/message-students",
    },
    {
      label: "Group Messages",
      to: "#/school_it/message-groups",
    },
    {
      label: "Export Students",
      to: "#/school_it/csv_export",
    },
    {
      label: "Students",
      to: "#/school_it/students",
    },
    {
      label: "Maintain Groups",
      to: "#/school_it/maintain_group",
    },
    {
      label: "Calendar",
      to: "#/school_it/calendar",
    },
    {
      label: <p>Download Progress</p>,
      to: "#/school_it/dowload_student_status",
    },
    {
      label: (
        <span onClick={handleLogout} className="sign-out">
          Sign Out
        </span>
      ),
    },
    // {
    //   label: "ACCOUNT SETTINGS",
    //   to: "#/counselor/profile",
    // },
    // {
    //   label: <span onClick={handleLogout} className="sign-out">
    //               SIGN OUT
    //          </span>,
    //   // to:"#/login"
    // }
  ];

  if (userData.school_student_progress_enable === true) {
    schoolItMenu = [
      ...schoolItMenu.slice(0, 2),
      {
        label: "Student Progress",
        to: "#/school_it/ccplus",
      },
      ...schoolItMenu.slice(2),
    ];
  }
  //   else if (userData.is_setup === false){
  //     schoolItMenu= [
  //       ...schoolItMenu.slice(0, 1),
  //     {
  //       label: "Student Statistics",
  //       to: "#/school_it/student_statistics",
  //     },
  //     ...schoolItMenu.slice(1)
  //     ]
  // }
  if (userData.is_setup === true) {
    console.log("object");
    schoolItMenu = [
      {
        label: "School Setup",
        to: "#/school_it/school_setup",
      },
      {
        label: "Global Goal",
        to: "#/school_it/global_goal",
      },
      ...schoolItMenu,
    ];
  }

  // if (userData.email === "tim7@sourceauditor.com"){
  //   schoolItMenu= [
  //     ...schoolItMenu.slice(0, 1),
  //     {
  //       label: "SFTP Process",
  //       to: "#/school_it/sftp_process",
  //     },
  //     ...schoolItMenu.slice(1)
  //   ]
  // }

  const adminMenu = [
    {
      label: "Export Students",
      to: "#/admin/export-students",
    },
    {
      label: "Statistics",
      to: "#/admin/statistics",
    },
    {
      label: "Login Analytics",
      to: "#/admin/login-analytics",
    },
    {
      label: "Student Progress",
      to: "#/admin/ccplus",
    },
    {
      label: "SFTP Information",
      to: "#/admin/sftp-info",
    },
    {
      label: "Send Invites",
      to: "#/admin/send-invites",
    },
    {
      label: "Schools",
      to: "#/admin/school",
    },
    {
      label: "Students",
      to: "#/admin/students",
    },
    {
      label: "Counselors",
      to: "#/admin/counselors",
    },
    {
      label: "Canned Messages",
      to: "#/admin/canned",
    },
    {
      label: "Update Goals For Schools",
      to: "#/admin/update_schoolgoals",
    },
    {
      label: "Create School IT",
      to: "#/admin/addschool_it",
    },
    {
      label: "Without Counselors",
      to: "#/admin/students_without_counselor",
    },
    {
      label: "Configuration List",
      to: "#/admin/configuration",
    },
    {
      label: "Colleges",
      to: "#/admin/college",
    },
    {
      label: "Recruiters",
      to: "#/admin/recruiters",
    },
    {
      label: "Export Result Report",
      to: "#/admin/exportResultReport",
    },
    {
      label: "Contract Setup",
      to: "#/admin/contractSetup",
    },
    {
      label: (
        <span onClick={handleLogout} className="sign-out">
          Sign Out
        </span>
      ),
    },
    // {
    //   label: "Searches",
    //   to: "#/admin/search-query",
    // },
    // {
    //   label: "ACCOUNT SETTINGS",
    //   to: "#/counselor/profile",
    // },
    // {
    //   label: <span onClick={handleLogout} className="sign-out">
    //               SIGN OUT
    //          </span>,
    //   // to:"#/login"
    // }
  ];

  useEffect(() => {
    if (userData) {
      getMenuList();
    }
  }, [userData, lang]);

  // Handle custom active states for menu items with multiple related routes
  useEffect(() => {
    const currentPath = location.pathname;
    
    // Define routes that should keep Goal Progress active
    const goalProgressRoutes = [
      '/counselor/all-students',
      '/counselor/on-track-student', 
      '/counselor/off-track-student',
      '/counselor/at-risk-student',
      '/counselor/at-brown-student',
      '/counselor/watchlist',
      '/super_admin/all-students',
      '/super_admin/on-track-student', 
      '/super_admin/off-track-student',
      '/super_admin/at-risk-student',
      '/super_admin/at-brown-student'
    ];

    // Define routes that should keep My Student List active
    const myStudentListRoutes = [
      '/counselor/current-student',
      '/counselor/invite-student',
      '/counselor/add-existing-student',
      '/counselor/export-file',
      '/counselor/import-files',
      '/super_admin/current-student',
      '/super_admin/invite-student',
      '/super_admin/add-existing-student',
      '/super_admin/export-file',
      '/super_admin/import-files'
    ];

    // Define routes that should keep Messages active
    const messagesRoutes = [
      '/counselor/message/student-message',
      '/counselor/message/recruiter-message',
      '/counselor/message/group-message',
      '/counselor/message/deleted-message',
      '/counselor/message/all-message',
      '/super_admin/message/student-message',
      '/super_admin/message/recruiter-message',
      '/super_admin/message/group-message',
      '/super_admin/message/deleted-message',
      '/super_admin/message/all-message'
    ];

    // Define routes that should keep Message Templates active
    const messageTemplatesRoutes = [
      '/super_admin/message/message-template'
    ];

    // Define routes that should keep Student Query active (Recruiter)
    const studentQueryRoutes = [
      '/recruiter/search-query',
      '/recruiter/school-query',
      '/recruiter/college-query',
      '/recruiter/query-result',
      '/recruiter/query-result-ccc'
    ];

    // Define routes that should keep Messages active (Recruiter)  
    const recruiterMessagesRoutes = [
      '/recruiter/students',
      '/recruiter/international-students',
      '/recruiter/counselors'
    ];

    // Define routes that should keep Calendar active (Recruiter)
    const recruiterCalendarRoutes = [
      '/recruiter/calendar'
    ];

    // Define routes that should keep Goals active (Student)
    const studentGoalsRoutes = [
      '/student/goal/cc-requirement',
      '/student/goal/csu-requirement', 
      '/student/goal/uc-requirement',
      '/student/dashboard',
      '/student/brown-dashboard'
    ];

    // Define routes that should keep Goals active (Parent)
    const parentGoalsRoutes = [
      '/parent/goal/cc-requirement',
      '/parent/goal/csu-requirement',
      '/parent/goal/uc-requirement',
      '/parent/goal/student-course-detail'
    ];

    // Small delay to ensure MetisMenu has rendered and language has updated
    const timer = setTimeout(() => {
      // Remove existing custom active classes
      const allMenuItems = document.querySelectorAll('.vertical-nav-menu .metismenu-link');
      allMenuItems.forEach(item => {
        item.classList.remove('custom-active-goal-progress', 'custom-active-student-list', 'custom-active-messages', 'custom-active-message-templates', 'custom-active-student-query', 'custom-active-recruiter-messages', 'custom-active-recruiter-calendar', 'custom-active-student-goals', 'custom-active-parent-goals');
      });

      // Check which routes match and add appropriate classes
      const goalProgressLinks = document.querySelectorAll('.vertical-nav-menu .metismenu-link');
      
      goalProgressLinks.forEach(link => {
        const linkText = link.textContent?.trim();
        const href = link.getAttribute('href');
        
        // Goal Progress active state
        if (goalProgressRoutes.includes(currentPath)) {
          if (linkText === 'Goal Progress' || 
              href === '#/counselor/all-students' || 
              href === '#/super_admin/all-students') {
            link.classList.add('custom-active-goal-progress');
          }
        }
        
        // My Student List active state
        if (myStudentListRoutes.includes(currentPath)) {
          if (linkText === 'My Student List' || 
              href === '#/counselor/current-student' || 
              href === '#/super_admin/current-student') {
            link.classList.add('custom-active-student-list');
          }
        }
        
        // Messages active state
        if (messagesRoutes.includes(currentPath)) {
          if (linkText === 'Messages' || linkText === t('myMessages') || 
              href === '#/counselor/message/student-message' || 
              href === '#/super_admin/message/student-message') {
            link.classList.add('custom-active-messages');
          }
        }
        
        // Message Templates active state
        if (messageTemplatesRoutes.includes(currentPath)) {
          if (linkText === 'Message Templates' || 
              href === '#/super_admin/message/message-template') {
            link.classList.add('custom-active-message-templates');
          }
        }
        
        // Student Query active state (Recruiter)
        if (studentQueryRoutes.includes(currentPath)) {
          if (linkText === 'Student Query' || 
              href === '#/recruiter/search-query') {
            link.classList.add('custom-active-student-query');
          }
        }
        
        // Recruiter Messages active state
        if (recruiterMessagesRoutes.includes(currentPath)) {
          if (linkText === 'Messages' || linkText === t('myMessages') || 
              href === '#/recruiter/students') {
            link.classList.add('custom-active-recruiter-messages');
          }
        }

        // Recruiter Calendar active state
        if (recruiterCalendarRoutes.includes(currentPath)) {
          if (linkText === 'Calendar' || linkText === t('myCalendar') || 
              href === '#/recruiter/calendar') {
            link.classList.add('custom-active-recruiter-calendar');
          }
        }
        
        // Student Goals active state
        if (studentGoalsRoutes.includes(currentPath)) {
          if (linkText === 'Goals' || linkText === t('goals') || 
              href === '#/student/goal/cc-requirement' ||
              href === '#/student/dashboard' ||
              href === '#/student/brown-dashboard') {
            link.classList.add('custom-active-student-goals');
          }
        }
        
        // Parent Goals active state
        if (parentGoalsRoutes.includes(currentPath)) {
          if (linkText === 'Goals' || linkText === t('goals') || 
              href === '#/parent/goal/cc-requirement') {
            link.classList.add('custom-active-parent-goals');
          }
        }
      });
    }, 200); // Increased timeout for language switching

    return () => clearTimeout(timer);
  }, [location.pathname, userData, lang]); // Added lang dependency

  const getMenuList = () => {
    let menuList = [];
    if (userData?.role === Roles.STUDENT_NAME) {
      menuList = studentMenu;
    } else if (userData?.role === Roles.PARENT_NAME) {
      menuList = parentMenu;
    } else if (
      userData?.role === Roles.COUNSELOR_NAME &&
      userData?.is_super_counselor === true
    ) {
      menuList = superCounselorMenu;
    } else if (userData?.role === Roles.COUNSELOR_NAME) {
      menuList = counselorMenu;
    } else if (userData?.role === Roles.RECRUITER_NAME) {
      menuList = recruiterMenu;
    } else if (userData?.role === Roles.SCHOOL_IT_NAME) {
      menuList = schoolItMenu;
    } else if (userData?.role === Roles.ADMIN_NAME) {
      menuList = adminMenu;
    }
    // Filter out any null/undefined entries that break react-metismenu flattening
    let filteredMenu = menuList.filter(Boolean);
    // During impersonation, remove Sign Out item to prevent admin accidental logout
    // Also remove Personal Notes to prevent access during impersonation
    if (impersonation?.isImpersonating) {
      filteredMenu = filteredMenu.filter((item) => {
        // Sign Out items have a span with className 'sign-out' in the label
        if (item?.label?.props?.className === 'sign-out') return false;
        // Hide Personal Notes during impersonation
        if (item?.to === '#/student/personal-notes') return false;
        return true;
      });
    }
    return filteredMenu;
  };

  return (
    <Fragment>
      <MetisMenu
        content={getMenuList()}
        activeLinkFromLocation
        className="vertical-nav-menu"
        activeLinkTo={selectedHref}
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
        onSelected={(e) => onMenuSelected(e)}
      />
      {/* <h5 className="app-sidebar__heading">UI Components</h5>
      <MetisMenu
        content={ComponentsNav}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
      <h5 className="app-sidebar__heading">Dashboard Widgets</h5>
      <MetisMenu
        content={WidgetsNav}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
      <h5 className="app-sidebar__heading">Forms</h5>
      <MetisMenu
        content={FormsNav}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
      <h5 className="app-sidebar__heading">Charts</h5>
      <MetisMenu
        content={ChartsNav}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      /> */}
    </Fragment>
  );
};
export default Nav;
